import { Base } from '@studiometa/js-toolkit';
import { Frame } from '@studiometa/ui';

/**
 * Header component
 */
export default class Blog extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Blog',
    components: {
      Frame,
    },
  };
}
